<template>
  <div class="fixed-price-box">
    <div class="fixed-price-bnt">
      <div class="price-input">
        <input type="number" class="fixed-price-input" v-model="fixedPrice" />
        <div class="token-logo">
          <img src="@/assets/mybox/home/musd52x52-max.png" />
        </div>
      </div>
    </div>
    <div class="fixed-price-tiptext">
      How much quotation do you want to give
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    fixedPrice(val) {
      console.log("fixedPrice", val);
      this.$emit("input", parseFloat(val));
    },
  },
  data() {
    return {
        fixedPrice: this.value,      
    };
  },
};
</script>
<style lang="scss" scoped>
.fixed-price-box {
  width: 100%;
  height: 11vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  .fixed-price-bnt {
    width: 100%;
    height: 1.1rem;
    border-radius: 26px;
    border: 2px solid #303030;
    display: flex;
    justify-content: center;
    align-items: center;
    .price-input {
      display: flex;
      justify-content: center;
      align-items: center;
      .fixed-price-input {
        font-size: 0.32rem;
        color: #303030;
        width: 30%;
        text-align: center;
      }
    }
    .token-logo {
      width: 0.32rem;
      height: 0.32rem;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .fixed-price-tiptext {
    position: absolute;
    top: 14%;
    left: 14%;
    padding: 0 4%;
    background: white;
    font-size: 0.2rem;
    color: #585858;
  }
}
</style>
